/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Row_From_LabelInputs */

const en_platform_row_from_label = /** @type {(inputs: Platform_Row_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from`)
};

const zh_hans1_platform_row_from_label = /** @type {(inputs: Platform_Row_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起价`)
};

const pt_br2_platform_row_from_label = /** @type {(inputs: Platform_Row_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a partir de`)
};

const es_platform_row_from_label = /** @type {(inputs: Platform_Row_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`desde`)
};

const fr_platform_row_from_label = /** @type {(inputs: Platform_Row_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`à partir de`)
};

const de_platform_row_from_label = /** @type {(inputs: Platform_Row_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ab`)
};

const ru_platform_row_from_label = /** @type {(inputs: Platform_Row_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`от`)
};

const it_platform_row_from_label = /** @type {(inputs: Platform_Row_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`da`)
};

/**
* | output |
* | --- |
* | "from" |
*
* @param {Platform_Row_From_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_row_from_label = /** @type {((inputs?: Platform_Row_From_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Row_From_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_row_from_label(inputs)
	if (locale === "pt-BR") return pt_br2_platform_row_from_label(inputs)
	if (locale === "es") return es_platform_row_from_label(inputs)
	if (locale === "fr") return fr_platform_row_from_label(inputs)
	if (locale === "de") return de_platform_row_from_label(inputs)
	if (locale === "ru") return ru_platform_row_from_label(inputs)
	if (locale === "it") return it_platform_row_from_label(inputs)
	return en_platform_row_from_label(inputs)
});